// Calculate a safe index to navigate to, bounded by zero and length - 1.
export const getSafeRowIndex = (currentIndex, keypress, data) => {
  if (keypress === 'down') {
    return (currentIndex + 1) % data.length;
  }

  return (currentIndex + (data.length - 1)) % data.length;
};
